import { create } from 'zustand';

type AssetState = {
  cachedAssets: Record<string, string>;
  addCachedAsset: (url: string, objectUrl: string) => void;
  cleanCachedAsset: () => void;
};

export const useAssetStore = create<AssetState>((set) => ({
  cachedAssets: {},
  addCachedAsset: (url, objectUrl) =>
    set((state) => ({
      cachedAssets: { ...state.cachedAssets, [url]: objectUrl },
    })),
  cleanCachedAsset: () => {
    set(() => ({ cachedAssets: {} }));
  },
}));
